export const SET_CURRENT_TAB =
  'client/modules/university-display/actions/SET_CURRENT_TAB';

export function setCurrentTab(currentTab) {
  return { type: SET_CURRENT_TAB, currentTab };
}

export default setCurrentTab;
